import {
    LIST_OBJECTS,
    LIST_OBJECTS_SUCCESS,
    LIST_OBJECTS_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    objects: null,
    error: null,
    loading: false
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_OBJECTS:
            return {
                ...state,
                loading: true
            }
        case LIST_OBJECTS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_OBJECTS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                objects: action.payload
            }
        default:
            return state;
    }
}